import React from "react";
import DropdownListItem from "components/Common/Dropdown/DropdownListItem";
import { Constants } from 'config/constants';

const CategoryDropdown = (props) => {
  const { isShow, dropdownData, onSelectOption, selectedSearchType } = props;

  let options
  if (Array.isArray(dropdownData)) {
    options = [...dropdownData];

    const couponsIndex = options.findIndex(item => item.name === Constants.ALL_COUPONS);
    const coupons = {...options[couponsIndex]};
    options = options.filter(item => item.name !== Constants.ALL_COUPONS);
    
    const weeklyAdsIndex = options.findIndex(item => item.slug === "from-our-weekly-ads");
    
    options.splice(weeklyAdsIndex + 1, 0, coupons);
  }

  return (
    <div
      className={
        isShow
          ? "categories-menu dropdown-show"
          : "categories-menu dropdown-hidden"
      }
    >
      <div className="list-menu">
        <ul>
          {options &&
            options.map((dropdownOption, index) => {
              return (
                <DropdownListItem
                  optionName={dropdownOption.name}
                  optionValue={dropdownOption.search_type}
                  onSelectOption={onSelectOption}
                  key={index}
                  selectedOptionValue={selectedSearchType}
                  onClose={() => {}}
                />
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default CategoryDropdown;
